import { _ as _define_property } from "@swc/helpers/_/_define_property";
import { isObject } from '../isObject';
import { parseRetryAfterMs } from '../retryAfter';
export const errorTextsPath = 'errors';
const ABORT_ERROR_NAMES = new Set([
    'CanceledError',
    'AbortError'
]);
const ABORT_ERROR_CODES = new Set([
    'ERR_CANCELED'
]);
const TIMEOUT_ERROR_CODES = new Set([
    'ECONNABORTED',
    'ETIMEDOUT'
]);
const NETWORK_ERROR_CODE = 'ERR_NETWORK';
/** Errors arriving in the body of server error responses. */ export var ServerError = /*#__PURE__*/ function(ServerError) {
    ServerError["MismatchingRelationshipVersion"] = "mismatchingRelationshipVersion";
    ServerError["CannotUpdateWithUnsentChanges"] = "CANNOT_UPDATE_WITH_UNSENT_CHANGES";
    ServerError["NoAmendmentDraftToApply"] = "NO_AMENDMENT_DRAFT_TO_APPLY";
    ServerError["AmendedServiceNotFound"] = "AMENDED_SERVICE_NOT_FOUND";
    ServerError["SalesTaxTaxableNotAllowedOnBundle"] = "SALES_TAX_TAXABLE_NOT_ALLOWED_ON_BUNDLE";
    ServerError["AgreementTaxSettingsWriteFrozen"] = "AGREEMENT_TAX_SETTINGS_WRITE_FROZEN";
    ServerError["TaxSettingsAmendmentUnavailable"] = "TAX_SETTINGS_AMENDMENT_UNAVAILABLE";
    ServerError["PhoneValidationFailed"] = "phoneValidationFailed";
    ServerError["DuplicateContact"] = "duplicateContact";
    ServerError["DuplicateContactIdentity"] = "DUPLICATE_CONTACT";
    ServerError["UserAlreadyInBusiness"] = "USER_ALREADY_IN_BUSINESS";
    ServerError["UnknownError"] = "unknownError";
    ServerError["InsufficientPermissions"] = "insufficient_permissions";
    ServerError["ConversationNotReady"] = "conversation_not_ready";
    ServerError["CreateFailed"] = "create_failed";
    ServerError["BuyerUserAssociatedWithVendor"] = "BuyerUserAssociatedWithVendor";
    ServerError["TargetUserNotBuyer"] = "TARGET_USER_NOT_BUYER";
    ServerError["DeactivatedBuyerRoleNotEditable"] = "DEACTIVATED_BUYER_ROLE_NOT_EDITABLE";
    ServerError["BankTransferAccountBlocked"] = "bankTransferAccountBlocked";
    ServerError["DuplicateNameExists"] = "DUPLICATE_NAME_EXISTS";
    ServerError["InvalidRelationshipStatus"] = "INVALID_RELATIONSHIP_STATUS";
    ServerError["ServiceTemplateAlreadyExists"] = "SERVICE_TEMPLATE_ALREADY_EXISTS";
    ServerError["NameAlreadyExists"] = "NAME_ALREADY_EXISTS";
    ServerError["ProposalTemplateNotFound"] = "PROPOSAL_TEMPLATE_NOT_FOUND";
    ServerError["ProposalTemplateDeleted"] = "PROPOSAL_TEMPLATE_DELETED";
    ServerError["TemplateNotValid"] = "TEMPLATE_NOT_VALID";
    ServerError["BulkRelationshipDraftsSubmitted"] = "BULK_RELATIONSHIP_DRAFTS_SUBMITTED";
    ServerError["BulkRelationshipDraftsAbandoned"] = "BULK_RELATIONSHIP_DRAFTS_ABANDONED";
    ServerError["BulkRelationshipDraftsChangedConcurrently"] = "BULK_RELATIONSHIP_DRAFTS_CHANGED_CONCURRENTLY";
    ServerError["BulkRelationshipDraftsAlreadyOpen"] = "BULK_RELATIONSHIP_DRAFTS_ALREADY_OPEN";
    ServerError["BulkRelationshipDraftsFileUnreadable"] = "BULK_RELATIONSHIP_DRAFTS_FILE_UNREADABLE";
    ServerError["BulkRelationshipDraftsTooManyClients"] = "BULK_RELATIONSHIP_DRAFTS_TOO_MANY_CLIENTS";
    ServerError["BulkRelationshipDraftsFileTooLarge"] = "BULK_RELATIONSHIP_DRAFTS_FILE_TOO_LARGE";
    ServerError["BulkRelationshipDraftsStepOrder"] = "BULK_RELATIONSHIP_DRAFTS_STEP_ORDER";
    ServerError["BulkRelationshipDraftsDuplicateServiceNames"] = "BULK_RELATIONSHIP_DRAFTS_DUPLICATE_SERVICE_NAMES";
    ServerError["BulkRelationshipDraftsPricingColumnsChanged"] = "BULK_RELATIONSHIP_DRAFTS_PRICING_COLUMNS_CHANGED";
    ServerError["BulkRelationshipDraftsRepeatedClientIdColumn"] = "BULK_RELATIONSHIP_DRAFTS_REPEATED_CLIENT_ID_COLUMN";
    ServerError["BulkRelationshipDraftsRepeatedClientNameColumn"] = "BULK_RELATIONSHIP_DRAFTS_REPEATED_CLIENT_NAME_COLUMN";
    ServerError["BulkRelationshipDraftsNotReady"] = "BULK_RELATIONSHIP_DRAFTS_NOT_READY";
    ServerError["BulkRelationshipDraftsStale"] = "BULK_RELATIONSHIP_DRAFTS_STALE";
    ServerError["BulkRelationshipDraftsAlreadyInProgress"] = "BULK_RELATIONSHIP_DRAFTS_ALREADY_IN_PROGRESS";
    ServerError["BulkRelationshipDraftsNotPermitted"] = "BULK_RELATIONSHIP_DRAFTS_NOT_PERMITTED";
    ServerError["ProposalTemplateNotRelatedToVendor"] = "PROPOSAL_TEMPLATE_NOT_RELATED_TO_VENDOR";
    ServerError["UserAlreadyAffiliatedWithBusiness"] = "USER_ALREADY_AFFILIATED_WITH_BUSINESS";
    ServerError["PendingInvitationAlreadyExists"] = "PENDING_INVITATION_ALREADY_EXISTS";
    ServerError["RecipientNotFound"] = "RECIPIENT_NOT_FOUND";
    ServerError["InvalidTeamInvitation"] = "INVALID_TEAM_INVITATION";
    ServerError["FailedToDeleteContactDueToExistingRelationships"] = "FAILED_TO_DELETE_CONTACT_DUE_TO_EXISTING_RELATIONSHIPS";
    ServerError["FailedToArchiveCustomerDueToAgreement"] = "FAILED_TO_ARCHIVE_CUSTOMER_DUE_TO_AGREEMENT";
    ServerError["FailedToDeleteCustomerDueToAgreement"] = "FAILED_TO_DELETE_CUSTOMER_DUE_TO_AGREEMENT";
    ServerError["CannotArchiveDeletedCustomer"] = "CANNOT_ARCHIVE_DELETED_CUSTOMER";
    ServerError["CannotUnarchiveDeletedCustomer"] = "CANNOT_UNARCHIVE_DELETED_CUSTOMER";
    ServerError["ContactVersionMismatch"] = "CLIENT_CONTACT_VERSION_MISMATCH";
    ServerError["ContactNotEditable"] = "CLIENT_CONTACT_NOT_EDITABLE";
    ServerError["ContactIdentityNotEditable"] = "CONTACT_NOT_EDITABLE";
    ServerError["ContactHasAssociations"] = "CONTACT_HAS_ASSOCIATIONS";
    ServerError["ClientContactAlreadyExists"] = "CLIENT_CONTACT_ALREADY_EXISTS";
    ServerError["CustomerArchived"] = "CUSTOMER_ARCHIVED";
    ServerError["DuplicateNativeClientContact"] = "DUPLICATE_NATIVE_CLIENT_CONTACT";
    ServerError["ClientBusinessHasNoOwner"] = "CLIENT_BUSINESS_HAS_NO_OWNER";
    ServerError["IncorrectStatusForPaidExternally"] = "incorrectStatusForPaidExternally";
    ServerError["RelationshipAlreadyApproved"] = "RELATIONSHIP_ALREADY_APPROVED";
    ServerError["UserWithEmailAlreadyExists"] = "USER_WITH_EMAIL_ALREADY_EXISTS";
    ServerError["RelationshipAlreadyTerminated"] = "RELATIONSHIP_ALREADY_TERMINATED";
    ServerError["ReviewerEmailIsSimilarToSellerEmail"] = "REVIEWER_EMAIL_IS_SIMILAR_TO_SELLER_EMAIL";
    ServerError["ReviewerEmailIsSimilarToBuyerEmail"] = "REVIEWER_EMAIL_IS_SIMILAR_TO_BUYER_EMAIL";
    ServerError["AdditionalRecipientUserAssociatedWithVendor"] = "ADDITIONAL_RECIPIENT_USER_ASSOCIATED_WITH_VENDOR";
    ServerError["DuplicateReviewerEmail"] = "DUPLICATE_REVIEWER_EMAIL";
    ServerError["CantCreateAgreementExternallyFromDraftWithServiceBundles"] = "CANT_CREATE_AGREEMENT_EXTERNALLY_FROM_DRAFT_WITH_SERVICE_BUNDLES";
    ServerError["UserAlreadySigned"] = "USER_ALREADY_SIGNED";
    ServerError["CounterSignatureMissing"] = "COUNTER_SIGNATURE_MISSING";
    ServerError["InvoiceWasVoided"] = "INVOICE_WAS_VOIDED";
    ServerError["InvoiceAlreadyApproved"] = "INVOICE_ALREADY_APPROVED";
    ServerError["InvoicePaymentNotRetryable"] = "INVOICE_PAYMENT_NOT_RETRYABLE";
    ServerError["NoAmendmentsToApprove"] = "NO_AMENDMENTS_TO_APPROVE";
    ServerError["EmailAlreadyRegistered"] = "EMAIL_ALREADY_REGISTERED";
    ServerError["EmailAlreadyVerified"] = "EMAIL_ALREADY_VERIFIED";
    ServerError["InvalidOTP"] = "INVALID_OTP";
    ServerError["OtpNotFound"] = "OTP_NOT_FOUND";
    ServerError["InvalidCurrentPassword"] = "INVALID_CURRENT_PASSWORD";
    ServerError["AdHocChargeNotFound"] = "AD_HOC_CHARGE_NOT_FOUND";
    ServerError["BillCommandNotFoundInService"] = "BILL_COMMAND_NOT_FOUND_IN_SERVICE";
    ServerError["InvalidScopeMissingUserInfo"] = "INVALID_SCOPE_MISSING_USER_INFO";
    ServerError["InvalidScopeMissingGmailSend"] = "INVALID_SCOPE_MISSING_GMAIL_SEND";
    ServerError["InvalidKeeperCredentials"] = "INVALID_KEEPER_CREDENTIALS";
    ServerError["IntegrationNotConnected"] = "INTEGRATION_NOT_CONNECTED";
    ServerError["BulkBillAlreadyInProgress"] = "BATCH_ALREADY_IN_PROGRESS";
    ServerError["BulkSendProposalsAlreadyInProgress"] = "BULK_SEND_PROPOSALS_ALREADY_IN_PROGRESS";
    ServerError["BatchNotInProgress"] = "BATCH_NOT_IN_PROGRESS";
    ServerError["BulkRelationshipDraftsNotFound"] = "BULK_RELATIONSHIP_DRAFTS_NOT_FOUND";
    ServerError["DraftNotFound"] = "DRAFT_NOT_FOUND";
    ServerError["MaxChargesExceeded"] = "MAX_CHARGES_EXCEEDED";
    ServerError["InvalidServiceStatusForBilling"] = "INVALID_SERVICE_STATUS_FOR_BILLING";
    ServerError["RelationshipNotBillable"] = "RELATIONSHIP_NOT_BILLABLE";
    ServerError["NoInvoiceForBillingDate"] = "NO_INVOICE_FOR_BILLING_DATE";
    ServerError["InvoiceNegativeTotal"] = "INVOICE_NEGATIVE_TOTAL";
    ServerError["TaxPreviewRequestInvalid"] = "TAX_PREVIEW_REQUEST_INVALID";
    ServerError["TotalsPreviewRequestInvalid"] = "TOTALS_PREVIEW_REQUEST_INVALID";
    ServerError["InvoiceRefundAmountExceeds"] = "INVOICE_REFUND_AMOUNT_EXCEEDS";
    ServerError["InvoiceRefundAmountLessThanZero"] = "INVOICE_REFUND_AMOUNT_LESS_THAN_ZERO";
    ServerError["InvoiceIsFullyRefunded"] = "INVOICE_IS_FULLY_REFUNDED";
    ServerError["InvoiceCalculateRefundParseQueryFailed"] = "INVOICE_CALCULATE_REFUND_PARSE_QUERY_FAILED";
    ServerError["InvoiceIsNotReadyForRefund"] = "INVOICE_IS_NOT_READY_FOR_REFUND";
    ServerError["InvoiceAlreadyHasOneRefundNotRefunded"] = "INVOICE_ALREADY_HAS_ONE_REFUND_NOT_REFUNDED";
    ServerError["InvoiceRefundInvalidAmount"] = "INVOICE_REFUND_INVALID_AMOUNT";
    ServerError["InvoiceRefundFeesNotSupported"] = "INVOICE_REFUND_FEES_NOT_SUPPORTED";
    ServerError["InvoiceRefundUnknownLineItem"] = "INVOICE_REFUND_UNKNOWN_LINE_ITEM";
    ServerError["InvoiceRefundDuplicateLineItem"] = "INVOICE_REFUND_DUPLICATE_LINE_ITEM";
    ServerError["InvoiceRefundAmountExceedsLineAmount"] = "INVOICE_REFUND_AMOUNT_EXCEEDS_LINE";
    ServerError["InvoiceRefundLinesAllZero"] = "INVOICE_REFUND_LINES_ALL_ZERO";
    ServerError["InvoiceCommandPaymentInvalidFundingSource"] = "INVOICE_COMMAND_PAYMENT_INVALID_FUNDING_SOURCE";
    ServerError["InvalidScheduleTime"] = "INVALID_SCHEDULE_TIME";
    ServerError["DraftAlreadyScheduled"] = "DRAFT_ALREADY_SCHEDULED";
    ServerError["MissingDraftOwnerDetails"] = "MISSING_DRAFT_OWNER_DETAILS";
    ServerError["EmailIsInvalid"] = "email is invalid";
    ServerError["AccountIsDisabled"] = "account is disabled";
    ServerError["PersonalAccountNotSupported"] = "PERSONAL_ACCOUNT_NOT_SUPPORTED";
    ServerError["EmailMailboxUnavailable"] = "EMAIL_MAILBOX_UNAVAILABLE";
    ServerError["DraftIsDeleted"] = "DRAFT_IS_DELETED";
    ServerError["DraftLinkedToRelationship"] = "DRAFT_LINKED_TO_RELATIONSHIP";
    ServerError["DraftNotArchived"] = "DRAFT_NOT_ARCHIVED";
    ServerError["ExplicitApprovalNotAllowedForExternalSign"] = "EXPLICIT_APPROVAL_NOT_ALLOWED_FOR_EXTERNAL_SIGN";
    ServerError["MultiVendorCustomerNotEditable"] = "MULTI_VENDOR_CUSTOMER_NOT_EDITABLE";
    ServerError["CustomerNotOwnedByVendor"] = "CUSTOMER_NOT_OWNED_BY_VENDOR";
    ServerError["APIKeyNotFound"] = "API_KEY_NOT_FOUND";
    ServerError["APIKeyRenameFailed"] = "API_KEY_RENAME_FAILED";
    ServerError["AccountAlreadyExists"] = "ACCOUNT_ALREADY_EXISTS";
    ServerError["InvoiceNotVoided"] = "INVOICE_NOT_VOIDED";
    ServerError["InvoiceNotPaidExternally"] = "INVOICE_NOT_PAID_EXTERNALLY";
    ServerError["LegalTermsNameAlreadyExists"] = "LEGAL_TERMS_NAME_ALREADY_EXISTS";
    ServerError["LegalTermsPdfTooLargeForSignatures"] = "LEGAL_TERMS_PDF_TOO_LARGE_FOR_SIGNATURES";
    ServerError["LegalTermsPdfRejectedBySignatureProvider"] = "LEGAL_TERMS_PDF_REJECTED_BY_SIGNATURE_PROVIDER";
    ServerError["LegalTermsSignatureNotEnabled"] = "LEGAL_TERMS_SIGNATURE_NOT_ENABLED";
    ServerError["LegalTermsSignatureRolesDrifted"] = "LEGAL_TERMS_SIGNATURE_ROLES_DRIFTED";
    ServerError["DocusealUnavailable"] = "DOCUSEAL_UNAVAILABLE";
    ServerError["RecordConflict"] = "RECORD_CONFLICT";
    ServerError["BuyerSignatureSlotAlreadySigned"] = "BUYER_SIGNATURE_SLOT_ALREADY_SIGNED";
    ServerError["BuyerAlreadyARecipient"] = "BUYER_ALREADY_A_RECIPIENT";
    ServerError["SignatureDocumentSetupIncomplete"] = "SIGNATURE_DOCUMENT_SETUP_INCOMPLETE";
    ServerError["SignatureSignerMissingEmail"] = "SIGNATURE_SIGNER_MISSING_EMAIL";
    ServerError["SignatureSubmissionRejected"] = "SIGNATURE_SUBMISSION_REJECTED";
    ServerError["SignatureSignersLocked"] = "SIGNATURE_SIGNERS_LOCKED";
    ServerError["SignatureDocumentNotAllowed"] = "SIGNATURE_DOCUMENT_NOT_ALLOWED";
    ServerError["SignatureDocumentFrozen"] = "SIGNATURE_DOCUMENT_FROZEN";
    ServerError["SignatureDocumentNotAllowedForExternalSign"] = "SIGNATURE_DOCUMENT_NOT_ALLOWED_FOR_EXTERNAL_SIGN";
    ServerError["AttachmentNotFound"] = "ATTACHMENT_NOT_FOUND";
    ServerError["AttachmentsTotalSizeExceeded"] = "ATTACHMENTS_TOTAL_SIZE_EXCEEDED";
    ServerError["DuplicateFileNameNotAllowed"] = "DUPLICATE_FILE_NAME_NOT_ALLOWED";
    ServerError["TooManyAttachments"] = "TOO_MANY_ATTACHMENTS";
    ServerError["AttachmentDisplayNameTooLong"] = "ATTACHMENT_DISPLAY_NAME_TOO_LONG";
    ServerError["RelationshipDraftTitleTooLong"] = "RELATIONSHIP_DRAFT_TITLE_TOO_LONG";
    ServerError["ValidationError"] = "VALIDATION_ERROR";
    ServerError["UnresolvedTemplateVariables"] = "UNRESOLVED_TEMPLATE_VARIABLES";
    ServerError["AccountTemporarilyLocked"] = "ACCOUNT_TEMPORARILY_LOCKED";
    ServerError["CustomPageTemplateDuplicateName"] = "CUSTOM_PAGE_TEMPLATE_DUPLICATE_NAME";
    ServerError["FundingSourceNotFound"] = "funding_source_not_found";
    ServerError["FundingSourceNotVerified"] = "funding_source_not_verified";
    ServerError["FundingSourceTiedToOpenAdHocInvoice"] = "FUNDING_SOURCE_TIED_TO_OPEN_AD_HOC_INVOICE";
    ServerError["FundingSourceAlreadyAuthorized"] = "FUNDING_SOURCE_ALREADY_AUTHORIZED";
    ServerError["FundingSourceStateChanged"] = "FUNDING_SOURCE_STATE_CHANGED";
    ServerError["FundingSourceNotReauthorizable"] = "FUNDING_SOURCE_NOT_REAUTHORIZABLE";
    ServerError["MandateAcceptanceEvidenceMissing"] = "MANDATE_ACCEPTANCE_EVIDENCE_MISSING";
    ServerError["FundingSourceDebitBlocked"] = "FUNDING_SOURCE_DEBIT_BLOCKED";
    ServerError["QboSubscriptionInactive"] = "QBO_SUBSCRIPTION_INACTIVE";
    ServerError["ServiceEffectiveDateTooFarInPast"] = "SERVICE_EFFECTIVE_DATE_TOO_FAR_IN_PAST";
    ServerError["ServiceEffectiveDateMustBeInFuture"] = "SERVICE_EFFECTIVE_DATE_MUST_BE_IN_FUTURE";
    ServerError["StageScheduleOnDateBeforeEffectiveDate"] = "STAGE_SCHEDULE_ON_DATE_BEFORE_EFFECTIVE_DATE";
    ServerError["BulkImportUnreadableFile"] = "BULK_IMPORT_UNREADABLE_FILE";
    ServerError["BulkImportMissingColumns"] = "BULK_IMPORT_MISSING_COLUMNS";
    ServerError["BulkImportInvalidColumns"] = "BULK_IMPORT_INVALID_COLUMNS";
    ServerError["BulkImportTooLarge"] = "BULK_IMPORT_TOO_LARGE";
    ServerError["BulkImportEmptyFile"] = "BULK_IMPORT_EMPTY_FILE";
    ServerError["TextStorageNotFound"] = "TEXT_STORAGE_NOT_FOUND";
    ServerError["CustomerNotFound"] = "CUSTOMER_NOT_FOUND";
    ServerError["StanfordTaxFirmIdentifierMalformed"] = "STANFORD_TAX_FIRM_IDENTIFIER_MALFORMED";
    ServerError["StanfordTaxFirmNotFound"] = "STANFORD_TAX_FIRM_NOT_FOUND";
    ServerError["StanfordTaxFirmNotActive"] = "STANFORD_TAX_FIRM_NOT_ACTIVE";
    ServerError["StanfordTaxLookupUnavailable"] = "STANFORD_TAX_LOOKUP_UNAVAILABLE";
    ServerError["KarbonPrimaryContactCardRequired"] = "KARBON_PRIMARY_CONTACT_CARD_REQUIRED";
    ServerError["SignatureFieldsNotCompleted"] = "SIGNATURE_FIELDS_NOT_COMPLETED";
    ServerError["CustomerAddressRequired"] = "CUSTOMER_ADDRESS_REQUIRED";
    ServerError["CompletedDocumentNotAvailable"] = "COMPLETED_DOCUMENT_NOT_AVAILABLE";
    ServerError["NotASignerOnThisDocument"] = "NOT_A_SIGNER_ON_THIS_DOCUMENT";
    ServerError["SigningClosedForSigner"] = "SIGNING_CLOSED_FOR_SIGNER";
    ServerError["RelationshipNotAwaitingApproval"] = "RELATIONSHIP_NOT_AWAITING_APPROVAL";
    ServerError["ProposalBeingEdited"] = "PROPOSAL_BEING_EDITED";
    ServerError["LegalTermsNotFound"] = "LEGAL_TERMS_NOT_FOUND";
    return ServerError;
}({});
function readBlobText(blob) {
    return new Promise((resolve)=>{
        const reader = new FileReader();
        reader.onload = ()=>resolve(String(reader.result));
        reader.onerror = ()=>resolve('');
        reader.readAsText(blob);
    });
}
function parseJsonOrText(text) {
    try {
        return JSON.parse(text);
    } catch (unused) {
        return text;
    }
}
export class ErrorResponse {
    static async withReadableBody(error) {
        const errorResponse = new ErrorResponse(error);
        if (errorResponse.body instanceof Blob) {
            errorResponse.body = parseJsonOrText(await readBlobText(errorResponse.body));
        }
        return errorResponse;
    }
    hasPhoneValidationError() {
        var _this_body_validationErrors_at;
        return isObject(this.body) && 'validationErrors' in this.body && Array.isArray(this.body.validationErrors) && ((_this_body_validationErrors_at = this.body.validationErrors.at(0)) === null || _this_body_validationErrors_at === void 0 ? void 0 : _this_body_validationErrors_at.includes('e164'));
    }
    hasServerError(type) {
        const typeAsArray = Array.isArray(type) ? type : [
            type
        ];
        const code = this.serverErrorCode();
        return code != null && typeAsArray.some((t)=>t === code);
    }
    serverErrorCode() {
        const body = this.body;
        if (typeof body === 'string') {
            return body || null;
        } else if (isObject(body)) {
            const knownErrorKeys = [
                'error',
                'errorCode'
            ];
            const key = knownErrorKeys.find((k)=>k in body && typeof body[k] === 'string');
            return key ? body[key] : null;
        } else {
            return null;
        }
    }
    isAbortError() {
        const err = this.maybeAxiosError;
        return isObject(err) && (typeof err.name === 'string' && ABORT_ERROR_NAMES.has(err.name) || typeof err.code === 'string' && ABORT_ERROR_CODES.has(err.code));
    }
    isTimeoutError() {
        const err = this.maybeAxiosError;
        return isObject(err) && typeof err.code === 'string' && TIMEOUT_ERROR_CODES.has(err.code);
    }
    isNetworkError() {
        const err = this.maybeAxiosError;
        return isObject(err) && err.code === NETWORK_ERROR_CODE;
    }
    isTransportFailure() {
        return this.isTimeoutError() || this.isNetworkError();
    }
    classifyRequestFailure() {
        if (this.isAbortError()) {
            return 'aborted';
        }
        if (this.isTransportFailure()) {
            return 'transportFailure';
        }
        if (this.status == null) {
            return 'unknown';
        }
        return this.status >= 500 ? 'serverError' : 'clientError';
    }
    hasStatus(status) {
        return this.status != null && status.includes(this.status);
    }
    serverErrorMessage() {
        const body = this.body;
        return isObject(body) && 'message' in body && typeof body.message === 'string' && body.message ? body.message : null;
    }
    hasErrorMessageIncluding(substring) {
        return isObject(this.body) && 'error' in this.body && typeof this.body.error === 'string' && this.body.error.includes(substring);
    }
    isTooManyAttemptsError() {
        return this.status === 429;
    }
    retryAfterMs(nowMs) {
        var _parseRetryAfterMs;
        return (_parseRetryAfterMs = parseRetryAfterMs(this.bodyRetryAfter(), nowMs)) !== null && _parseRetryAfterMs !== void 0 ? _parseRetryAfterMs : parseRetryAfterMs(this.responseHeader('retry-after'), nowMs);
    }
    isBadGateway() {
        return this.status === 502;
    }
    validationErrorCode() {
        return isObject(this.body) && Array.isArray(this.body.errors) && isObject(this.body.errors[0]) ? this.body.errors[0].code || null : null;
    }
    context() {
        if (!this.body || !isObject(this.body) || !('context' in this.body) || !isObject(this.body.context)) {
            return undefined;
        }
        return this.body.context;
    }
    bodyRetryAfter() {
        return isObject(this.body) ? this.body.retryAfter : undefined;
    }
    responseHeader(name) {
        const error = this.maybeAxiosError;
        const response = isObject(error) && isObject(error.response) ? error.response : null;
        return response != null && isObject(response.headers) ? response.headers[name] : undefined;
    }
    constructor(maybeAxiosError){
        _define_property(this, "maybeAxiosError", void 0);
        _define_property(this, "status", void 0);
        _define_property(this, "body", void 0);
        this.maybeAxiosError = maybeAxiosError;
        if (maybeAxiosError instanceof ErrorResponse) {
            this.status = null;
            Object.assign(this, maybeAxiosError);
        } else {
            this.status = isObject(this.maybeAxiosError) && 'response' in this.maybeAxiosError && isObject(this.maybeAxiosError.response) && typeof this.maybeAxiosError.response.status === 'number' && this.maybeAxiosError.response.status > 0 ? this.maybeAxiosError.response.status : null;
            this.body = isObject(this.maybeAxiosError) && 'response' in this.maybeAxiosError && isObject(this.maybeAxiosError.response) && this.maybeAxiosError.response.data;
        }
    }
}
